import { request } from '../../client';
import type { ApiRequestConfig } from '../../client/types';

/**
 *
 *
 * @returns string OK
 */
export function getV1Smartthermostat(requestConfig: ApiRequestConfig = {}): Promise<string> {
  return request(
    {
      method: 'GET',
      path: `/v1/smartthermostat/`,
    },
    requestConfig,
  );
}
